// This is your plugin object. It can be exported to be used anywhere.
const timebomb = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    Vue.prototype.$timebomb = (timer) => {

      const toTimestamp = (strDate) => {
        const dateParse = Date.parse(strDate)
        return (dateParse / 1000)
      }

      const now = new Date()
      const date = now.getFullYear() + ' ' + (now.getMonth() + 1) + ' ' + now.getDate()

      const hours = now.getHours()

      const tempMinutes = now.getMinutes()
      const minutes = (tempMinutes < 10) ? `0${tempMinutes}` : tempMinutes

      const tempSeconds = now.getSeconds()
      const seconds = (tempSeconds < 10) ? `0${tempSeconds}` : tempSeconds

      const time = hours + ':' + minutes + ':' + seconds
      const dateTime = date + ' ' + time

      const current = toTimestamp(dateTime)
      // const deadline = toTimestamp('2018 2 26 17:00:00')
      const deadline = toTimestamp(timer)

      let bomb = false
      if (current > deadline) {
        bomb = true
      }

      console.log('dateTime: ', dateTime)
      console.log('current: ', current)
      console.log('deadline: ', deadline)
      console.log('bomb: ', bomb)

      return bomb
    }
  }
};

// Usage example:
// const bomb = this.$timebomb('2018 2 26 17:00:00')
//
// if (!bomb) {
//   console.log('Page is not live yet.')
//   const host = window.location.host
//   const enemy = 'www.wuerttfv.de'
//   const refugee = 'http://www.wfv.wortundform.de/'
//
//   console.log('host: ', host)
//   if (host === enemy) {
//     // redirect to temp. domain
//     window.location.replace(refugee)
//   }
// }
export default timebomb



// WEBPACK FOOTER //
// ./src/plugins/timebomb.js